import React, { useEffect, useState } from 'react';
import { TextField, Button, Switch, FormControlLabel, Box, Typography, Autocomplete, } from '@mui/material';
import { PlusCircle, ArrowLeft, ChevronLeft, User, Gift } from 'react-feather';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../../components/Toast';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format, isValid, parse } from 'date-fns';



export default function AddBonus() {
    const [endDate, setEnddate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [username, setUserName] = useState([]); // Initialize as an empty array
    const [active, setActive] = useState(true);
    const [errors, setErrors] = useState({}); // State to hold validation errors
    const [userNameOptions, setUserNameOptions] = useState([])
    const [monthlyBonus, setMonthlyBonus] = useState('');
    const [extraPercentage, setExtraPercentage] = useState('');
    const [isLoading, setIsloading] = useState(false);

    const token = useSelector((state) => state.auth.token);
    const userID = useSelector((state) => state.auth.id);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        fetchUsers();
    }, [token, userID]);

    const fetchUsers = async () => {
        const input_token = 'ALL_USERS';
        const apiUrl = 'list_of_firm_users';

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data) {
                setUserNameOptions(data.clients);

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');

            } else if (data === undefined) {
                await Toastmessage('No response from server', false);

            } else {
                await Toastmessage(data?.message || 'An error occurred', false);

            }
        } catch (error) {

        }

    }

    const handleActiveChange = (event) => {
        setActive(event.target.checked);
    };

    const validateForm = () => {
        const newErrors = {};

        // Check if the array is empty for the multi-select dropdown
        if (username.length === 0) {
            newErrors.username = "Username is required";
        }

        if (!startDate || String(startDate).trim() === '' || startDate == null) {
            newErrors.startDate = "From Date is required";
        } else {
            let parsedDate;
            if (typeof startDate === 'string') {
                parsedDate = new Date(startDate);
            } else {
                parsedDate = startDate;
            }

            if (!isValid(parsedDate)) {
                newErrors.startDate = "Invalid date. Please provide a valid date.";
            } else {
                const formattedDate = format(parsedDate, 'MM/dd/yyyy');
                const reParsedDate = parse(formattedDate, 'MM/dd/yyyy', new Date());
                if (!isValid(reParsedDate)) {
                    newErrors.startDate = "Invalid date format. Please use 'MM/dd/yyyy'.";
                }
            }
        }

        // endtDate validation
        if (!endDate || String(endDate).trim() === '') {
            newErrors.endDate = "To Date is required";
        } else {
            // Attempt to parse the endDate if it's a string, or check its validity directly if it's a Date object
            let parsedDate;
            if (typeof endDate === 'string') {
                parsedDate = new Date(endDate); // Parse the string into a Date object
            } else {
                parsedDate = endDate; // Assume it's already a Date object
            }

            if (!isValid(parsedDate)) {
                newErrors.endDate = "Invalid date. Please provide a valid date.";
            } else {
                // Format the date to MM/dd/yyyy to validate the format
                const formattedDate = format(parsedDate, 'MM/dd/yyyy');

                // Optionally validate the formatted string (e.g., if further checks are needed)
                const reParsedDate = parse(formattedDate, 'MM/dd/yyyy', new Date());
                if (!isValid(reParsedDate)) {
                    newErrors.endDate = "Invalid date format. Please use 'MM/dd/yyyy'.";
                }
            }
        }
        if (monthlyBonus.length === 0) {
            newErrors.monthlyBonus = "Monthly Bonus is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return; // Exit if validation fails
        }

        const formattedStartDate = format(new Date(startDate), 'yyyy-MM-dd'); // Format the start date
        const formattedEndDate = format(new Date(endDate), 'yyyy-MM-dd'); // Format the end date

        const addBonusApi = async () => {
            setIsloading(true);
            const input_token = monthlyBonus + 'CREATE_BONUS';
            const apiUrl = 'create_bonus';

            const formData = {
                auth_token: token, // Token from Redux state
                login_user_id: userID, // User ID from Redux state
                duration_start_date: formattedStartDate, // Start date
                duration_end_date: formattedEndDate, // End date
                extra_bonus: extraPercentage || '0', // Extra bonus percentage, default to '0' if empty
                bonus: monthlyBonus || '0', // Monthly bonus, default to '0' if empty
                status: active ? '1' : '0', // Active status as '1' for true or '0' for false
                users: username.map((user) => user.id), // Extract user IDs from the selected users
            };

            try {
                const data = await authApi(input_token, formData, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate(-1), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false);
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false);
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false);
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false);
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addBonusApi();
    };


    const RequiredLabel = ({ children }) => (
        <>
            {children} <span style={{ color: 'red' }}>*</span>
        </>
    );

    const handleDateChange = (field, value) => {
        setStartDate(value)
    };
    const handleEndChange = (field, value) => {
        setEnddate(value)
    };


    return (

        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <Gift style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Add Bonus
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/bonus"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Bonus List
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                <form onSubmit={handleSubmit}>
                    <Box className="sub-header">
                        <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                            <Link to="/bonus" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                <ArrowLeft size={20} style={{ marginRight: '8px' }} /> {/* Add margin for spacing */}
                                Add New Bonus
                            </Link>
                        </Typography>
                        <FormControlLabel
                            control={<Switch checked={active} onChange={handleActiveChange} />}
                            label={
                                <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                                    Active : {active ? 'Yes' : 'No'}
                                </Typography>
                            }
                        />
                    </Box>
                    <Grid container spacing={4} sx={{ mt: 2 }}>
                        {/* First Row */}
                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                            <Typography><RequiredLabel>Select User</RequiredLabel></Typography>
                            <Autocomplete
                                multiple
                                options={userNameOptions}
                                getOptionLabel={(option) => option.full_name}
                                value={username}
                                onChange={(event, newValue) => setUserName(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Users"
                                        variant="outlined"
                                        error={!!errors.username}
                                        helperText={errors.username}
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                <Typography>
                                    <RequiredLabel>From Date</RequiredLabel>
                                </Typography>
                                <DatePicker
                                    value={startDate}
                                    onChange={(newValue) => handleDateChange('startDate', newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Enter Payment Date"
                                            error={!!errors.startDate} // Highlight field if there's an error
                                            helperText={errors.startDate || ''} // Display the error message
                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                        />
                                    )}
                                />
                                {errors.startDate && (
                                    <Typography color="error" sx={{ marginLeft: '10px', marginTop: '4px', fontSize: '12px' }}>
                                        {errors.startDate}
                                    </Typography>
                                )}

                            </Grid>
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                <Typography>
                                    <RequiredLabel>To Date</RequiredLabel>
                                </Typography>
                                <DatePicker
                                    value={endDate}
                                    onChange={(newValue) => handleEndChange('endtDate', newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Enter To Date"
                                            error={!!errors.endDate} // Highlight field if there's an error
                                            helperText={errors.endDate || ''} // Display the error message
                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                        />
                                    )}
                                />
                                {errors.endDate && (
                                    <Typography color="error" sx={{ marginLeft: '10px', marginTop: '4px', fontSize: '12px' }}>
                                        {errors.endDate}
                                    </Typography>
                                )}
                            </Grid>
                        </LocalizationProvider>


                        {/* Second Row */}
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <Typography><RequiredLabel>Monthly Bonus Amount ($)</RequiredLabel></Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter the monthly bonus amount"
                                variant="outlined"
                                value={monthlyBonus}
                                error={!!errors.monthlyBonus}
                                helperText={errors.monthlyBonus}
                                InputProps={{
                                    sx: { borderRadius: '8px' },
                                    inputProps: { maxLength: 5, inputMode: 'numeric', pattern: '[0-9]*' },
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,5}$/.test(value)) {
                                        setMonthlyBonus(value);
                                    }
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                            <Typography>Extra Bonus Percentage</Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter the percentage value"
                                variant="outlined"
                                value={extraPercentage}
                                error={!!errors.extraPercentage}
                                helperText={errors.extraPercentage}
                                InputProps={{
                                    sx: { borderRadius: '8px' },
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,3}$/.test(value)) {
                                        setExtraPercentage(value);
                                    }
                                }}
                            />
                        </Grid>

                    </Grid>

                    <Grid item={12} sx={{ textAlign: 'center', marginTop: '30px' }}>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={isLoading}
                            startIcon={<PlusCircle size={20} />}
                             className='btn-theme-button'
                        >
                            Add New Bonus
                        </Button>
                    </Grid>

                </form>
            </Box>

        </Box>
    );
}
